import { render, staticRenderFns } from "./SitchModifierGroupListConfig.vue?vue&type=template&id=a93849f8&scoped=true&"
import script from "./SitchModifierGroupListConfig.vue?vue&type=script&lang=ts&"
export * from "./SitchModifierGroupListConfig.vue?vue&type=script&lang=ts&"
import style0 from "./SitchModifierGroupListConfig.vue?vue&type=style&index=0&id=a93849f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a93849f8",
  null
  
)

export default component.exports